import intro from '../pages/intro/page.js';
import outro from '../pages/outro_fact/page.js';
import game from '../pages/puzzle/page.js';

let parent;
let _clb;

const intro_page=()=>intro.show({
	cls:'',
	header:'Solve the Puzzle',
	desc:[
		'Before you reach the Jimmy Carter National Historic Park, you have to go over some train tracks.',
		'Can you unscramble this puzzle so you can be safe when crossing the tracks?'
	],
	clb:game_page,
	parent
});

const game_page=()=>game.show({
	parent,
	clb:outro_page
});

const outro_page=()=>outro.show({
	cls:'puzzle',
	header:'AMAZING!',
	desc:[
		'You made it across the tracks.',
		'Welcome to Plains, Georgia!'
	],
	fact:'There are 4,600 miles of active railroad tracks in Georgia.',
	parent,
	clb:()=>{
		if(_clb) _clb();
		_clb = undefined;
	}
})

const _ext={
	start:({container,clb})=>{
		parent = container;
		_clb=clb;
		intro_page();
	},
	stop:()=>{
		game.hide();
	}
}

export default _ext;
